import { render, staticRenderFns } from "./Mallki.vue?vue&type=template&id=2d90d4e3"
import script from "./Mallki.vue?vue&type=script&lang=js"
export * from "./Mallki.vue?vue&type=script&lang=js"
import style0 from "./Mallki.vue?vue&type=style&index=0&id=2d90d4e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports